import React from 'react';
import TableHeader from '../../BaseComponents/TableHeader';
import './TeamsTable.scss';
import TeamsTableRow from './TeamsTableRow';
import { Team } from '../../../api/teams';

const headerColumns = [
  { title: 'Name', key: 'name', minWidth: '200px', flex: 0 },
  { title: 'Description', key: 'description', minWidth: '280px', flex: 1 },
  { title: '', key: 'actions', minWidth: '48px', flex: 0 },
];

type Props = {
  teams: Team[];
  onView: (team: Team) => void;
  onEdit: (team: Team) => void;
  tableBodyRef?: React.RefObject<HTMLDivElement | null>;
};

const TeamsTable: React.FC<Props> = ({
  teams,
  onView,
  onEdit,
  tableBodyRef,
}) => {
  return (
    <div className='scroll-container'>
      <div className='table-container teams-table'>
        <TableHeader headerColumns={headerColumns} gap={'24px'} />
        <div className='table-body' ref={tableBodyRef}>
          {teams.map((team) => (
            <TeamsTableRow
              key={team.id}
              team={team}
              onView={onView}
              onEdit={onEdit}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamsTable;
